import { HelpText } from "Utilities";

export const helpTextCache: Record<number, HelpText> = {};